import { NotFoundError } from '@cian/peperrors';

import { sendMessage } from './sendMessage';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { retrySendFileMessage } from '../sendFileMessage/retrySendFileMessage';
import { sendOfferMessage } from '../sendOfferMessage';

export const retrySendMessage =
  (currentChatId: string): TThunkAction<void> =>
  (dispatch, getState, { logger, custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    const { openedChats } = getState();

    const currentChat = openedChats[currentChatId];

    if (!currentChat) {
      const exception = new NotFoundError({
        domain: EExceptionDomain.Messages,
        message: 'Не удалось повторно отправить сообщение, чат не найден',
        details: { currentChatId },
      });

      logger.error(exception);

      return;
    }

    const events = Array.from(clientEvents.entries());

    events.forEach(([key, { status, type }]) => {
      if (status !== ERequestApiStatus.Failed || type !== EWsClientEventType.Message) {
        return;
      }

      const messageItem = messagesMap.get(key);

      if (!messageItem || messageItem.message.chatId !== currentChatId) {
        return;
      }

      const pendingFiles = currentChat.pendingFiles?.[key];

      if (messageItem.message.message.offers?.length) {
        clientEvents.delete(key);

        dispatch(
          sendOfferMessage({ chatId: currentChatId, offer: messageItem.message.message.offers[0], messageId: key }),
        );

        return;
      }

      // Сообщение с одним фото-файлом в начальной реализации
      if (pendingFiles?.blobFiles?.length || pendingFiles?.uploadedFiles?.length) {
        clientEvents.delete(key);

        dispatch(retrySendFileMessage({ chatId: currentChatId, messageId: key, pendingFiles }));

        return;
      }

      clientEvents.delete(key);
      dispatch(sendMessage({ text: messageItem.message.message.message, chatId: currentChatId, messageId: key }));
    });
  };
